export default __webpack_public_path__ + "static/media/Fair-02.ebd71ee1.png";